import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import ReactModal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';
import Heading from '../text/Heading';

const ModalWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .modal {
    overflow-x: hidden;
    &__top {
      background-color: ${getTheme('black', '_800')};
      padding: ${getTheme('padding', 'verticalXL')} ${getTheme('padding', 'horizontalXL')};
      display: flex;
    }
    &__top-heading {
      margin: 0;
      color: ${getTheme('textColor', 'base')};
      font-weight: 600;
    }
    &__close {
      cursor: pointer;
      border: 0;
      margin-left: auto;
      padding: 0;
      font-size: inherit;
      background: transparent;
      color: ${getTheme('textColor', 'base')};
      svg {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
    &__content {
      position: relative;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      background-color: ${getTheme('bg', 'light1')};
    }
  }
`;
ReactModal.setAppElement('#root');
ReactModal.defaultStyles.overlay.zIndex = 3;
ReactModal.defaultStyles.overlay.backgroundColor = 'rgba(0,0,0,.6)';
ReactModal.defaultStyles.content.backgroundColor = 'transparent';
ReactModal.defaultStyles.content.border = '0';
ReactModal.defaultStyles.content.borderRadius = '8px';
ReactModal.defaultStyles.content.padding = '0';

class AlarmsModal extends Component {
  render() {
    if (this.props.wontClose) {
      ReactModal.defaultStyles.overlay.backgroundColor = '#666666';
    }
    return (
      <ReactModal
        isOpen={this.props.isOpen}
        contentLabel={this.props.modalTitle}
        onRequestClose={this.props.closeModal}
        shouldFocusAfterRender={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={!this.props.wontClose}
      >
        <ModalWrapper className="modal">
          <div className="modal__top">
            <Heading level="heading2" className="modal__top-heading">
              <h3>{this.props.modalTitle}</h3>
            </Heading>
            {!this.props.wontClose && (
              <button
                type="button"
                onClick={this.props.closeModal}
                className="modal__close"
                aria-label="Close"
              >
                <FontAwesomeIcon icon={faTimesCircle} />
              </button>
            )}
          </div>
          <div className="modal__content">{this.props.children}</div>
        </ModalWrapper>
      </ReactModal>
    );
  }
}

export default AlarmsModal;



// WEBPACK FOOTER //
// ./src/components/modal/Modal.js